module.exports = __webpack_public_path__ + "img/hsk_1.30e0d259.png";